/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CodebookService } from 'src/services/codebook.service';

@Injectable({
   providedIn: 'root',
})
export class LocalStorageService {
   constructor(private codebookService: CodebookService) {}

   set(key: string, value: any) {
      localStorage.setItem(key, value);
   }

   get(key: string) {
      return localStorage.getItem(key);
   }

   remove(key: string) {
      localStorage.removeItem(key);
   }

   check(key: string) {
      let checked = false;
      if (localStorage.getItem(key) !== null) {
         checked = true;
      }

      return checked;
   }

}
